import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["date", "greeting"]

    connect() {
        try {
            const now = new Date()
            const hour = now.getHours()

            if (this.hasGreetingTarget) {
                const greeting =
                    hour < 12 ? "Good morning." : hour < 18 ? "Good afternoon." : "Good evening."
                this.greetingTarget.textContent = greeting
            }

            if (this.hasDateTarget) {
                const weekday = new Intl.DateTimeFormat(undefined, { weekday: "short" }).format(now)
                const month = new Intl.DateTimeFormat(undefined, { month: "long" }).format(now)
                const day = new Intl.DateTimeFormat(undefined, { day: "numeric" }).format(now)
                this.dateTarget.textContent = `${weekday} · ${month} ${day}`
            }
        } catch (e) {
            // If Intl fails for any reason, keep server-rendered text.
        }
    }
}

